/** @file mesh.setHull: how many leading vertices form the ordered outline of a mesh. */
import { z } from 'zod';
import { defineCommand } from '../defineCommand';
import { checkMeshTopology } from './checkMeshTopology';
import { meshDraft } from './meshDraft';

/** mesh.setHull: 3 ≤ hull (zod) ≤ vertex count (meshTopology); interior vertices follow the outline; the current hull is a no-op. */
export const command = defineCommand({
  name: 'mesh.setHull',
  description: 'Set how many leading vertices of a mesh form its ordered outline (3..vertex count; interior vertices follow).',
  input: z.object({ target: z.string().min(1), hull: z.number().int().min(3) }).strict(),
  apply(draft, input, ctx) {
    const { mesh } = meshDraft(draft, ctx, input.target);
    if (mesh.hull === input.hull) return;
    mesh.hull = input.hull;
    checkMeshTopology(draft, mesh);
    draft.meta.updatedAt = ctx.now;
  },
});
